import React from "react";
import { Box, Stack, Typography, IconButton } from "@mui/material";
import { CV2_COLUMN_HEADER_HEIGHT, CHAT_LIST_WIDTH } from "../../../constants/chatV2Constants";
import { IconDetailsSplit24 } from "./ChatV2Icons";
import ChatBar from "../ChatComponents/ChatBar";
import "./chatV2Overrides.css";
import "./chatListRowV2.css";

function ChatList({
  headerTitle = "",
  onToggleNav,
  chatBarProps,
}) {
  return (
    <Box
      component="section"
      className="chatv2-list-column"
      sx={{
        width: CHAT_LIST_WIDTH,
        flexShrink: 0,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        bgcolor: "#fff",
        borderRight: "1px solid #E5E9EC",
        overflow: "hidden",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        gap={1}
        sx={{
          height: CV2_COLUMN_HEADER_HEIGHT,
          minHeight: CV2_COLUMN_HEADER_HEIGHT,
          px: 2,
          borderBottom: "1px solid #E5E9EC",
          boxSizing: "border-box",
          flexShrink: 0,
        }}
      >
        <IconButton
          size="small"
          aria-label="Toggle chat navigation"
          onClick={onToggleNav}
          sx={{ p: 0, width: 24, height: 24, transform: "rotate(180deg)" }}
        >
          <IconDetailsSplit24 />
        </IconButton>
        <Typography
          sx={{
            fontSize: 18,
            fontWeight: 500,
            color: "#061522",
            lineHeight: "26px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {headerTitle}
        </Typography>
      </Stack>

      <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <ChatBar {...chatBarProps} variant="v2" />
      </Box>
    </Box>
  );
}

export default ChatList;
